import { defineSeasonalIcon } from './seasonal-icon';

export enum HalloweenIcon {
  AXE = 'axe',
  BAT = 'bat',
  BONES = 'bones',
  BROOM = 'broom',
  CANDELABRA = 'candelabra',
  CANDLE = 'candle',
  CANDY = 'candy',
  CANDY_CORN = 'candyCorn',
  CASTLE = 'castle',
  CAT = 'cat',
  CAULDRON = 'cauldron',
  CHAINS = 'chains',
  COFFIN = 'coffin',
  CRYSTAL_BALL = 'crystalBall',
  EYE = 'eye',
  FENCE = 'fence',
  FLAME = 'flame',
  FRANKENSTEIN = 'frankenstein',
  GHOST = 'ghost',
  GRAVE_CROSS = 'graveCross',
  HAUNTED_HOUSE = 'hauntedHouse',
  HAUNTED_TREE = 'hauntedTree',
  HOURGLASS = 'hourglass',
  KEY = 'key',
  LANTERN = 'lantern',
  MAGIC_WAND = 'magicWand',
  MOON = 'moon',
  MOON_CLOUD = 'moonCloud',
  MUMMY = 'mummy',
  MUSHROOM = 'mushroom',
  OWL = 'owl',
  PENTAGRAM = 'pentagram',
  PITCHFORK = 'pitchfork',
  POISON_APPLE = 'poisonApple',
  POTION = 'potion',
  PUMPKIN = 'pumpkin',
  RAVEN = 'raven',
  SCREAM_MASK = 'screamMask',
  SCYTHE = 'scythe',
  SKULL = 'skull',
  SNAKE = 'snake',
  SPELL_BOOK = 'spellBook',
  SPIDER = 'spider',
  TOMBSTONE = 'tombstone',
  VAMPIRE = 'vampire',
  WEB = 'web',
  WITCH_HAT = 'witchHat',
  WOLF_HEAD = 'wolfHead',
  ZOMBIE_HAND = 'zombieHand',
}

// Same shape as the Pulse line icons (24-grid, fill inherits currentColor) so they drop into any icon slot.
const ICON_PATHS: Record<HalloweenIcon, string> = {
  [HalloweenIcon.CANDELABRA]:
    'M12 1c1 1.4 1.6 2.3 1.6 3.2a1.6 1.6 0 0 1-3.2 0C10.4 3.3 11 2.4 12 1zM5 4c1 1.4 1.6 2.3 1.6 3.2a1.6 1.6 0 0 1-3.2 0C3.4 6.3 4 5.4 5 4zm14 0c1 1.4 1.6 2.3 1.6 3.2a1.6 1.6 0 0 1-3.2 0c0-.9.6-1.8 1.6-3.2zM11 6h2v6h-2zM4 9h2v3H4zm14 0h2v3h-2zM3 12h18v2h-7v5h2v3H8v-3h2v-5H3z',
  [HalloweenIcon.POISON_APPLE]:
    'M12 6c-1.2-1.2-3-1.8-4.6-1.2C4 6 2.6 9.8 4 14c1.2 3.6 3.6 7 6 7 .8 0 1.4-.3 2-.6.6.3 1.2.6 2 .6 2.4 0 4.8-3.4 6-7 .9-2.6.6-5-.6-6.6l-2.6 1.6-1-1.8 2.4-1.5C16.6 4.4 14.4 4 13 5.2L12 6zm.2-4.2c1.8-.2 3.2.4 4 1.6-1.8.2-3.2-.4-4-1.6zM9.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM12 14l-1.2 2.4h2.4z',
  [HalloweenIcon.SCREAM_MASK]:
    'M12 2C7 2 4 6 4 11c0 6 4 11 8 11s8-5 8-11c0-5-3-9-8-9zM8 8c1.5 1 2 3 1.5 5-1.5-.5-2.5-2-2.5-4 0-.5.5-1 1-1zm8 0c.5 0 1 .5 1 1 0 2-1 3.5-2.5 4-.5-2 0-4 1.5-5zm-4 5c1.5 0 2.5 2.5 2.5 5s-1 3-2.5 3-2.5-.5-2.5-3 1-5 2.5-5z',
  [HalloweenIcon.AXE]: 'M3 21 15 9l-2-2L1 19zM14 2c4 0 7 3 8 6-2-1-4 0-6 2l-3-3c1-2 2-4 1-5z',
  [HalloweenIcon.CANDY_CORN]: 'M12 2l7 20H5zM8.4 12h7.2l.7 2H7.7zM6.3 18h11.4l.7 2H5.6z',
  [HalloweenIcon.CASTLE]: 'M3 22V8h3V5h2v3h2V5h2v3h2V5h2v3h2V5h2v3h3v14h-6v-5h-4v5zM8 12h2v3H8zm6 0h2v3h-2z',
  [HalloweenIcon.CHAINS]:
    'M7 4a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h2v-2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1h2V8a4 4 0 0 0-4-4zm8 5h-2v2h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-1h-2v1a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4z',
  [HalloweenIcon.FENCE]: 'M4 5l2-3 2 3v17H4zM10 5l2-3 2 3v17h-4zM16 5l2-3 2 3v17h-4zM2 9h20v2H2zM2 15h20v2H2z',
  [HalloweenIcon.FLAME]:
    'M12 2c1 4 5 6 5 11a5 5 0 0 1-10 0c0-2 1-3 2-4 0 2 1 3 2 3 0-3-1-6 1-10zm0 11c-1 2-1 4 0 5s2-1 2-3-1-2-2-2z',
  [HalloweenIcon.FRANKENSTEIN]:
    'M5 6h14v10c0 3-3 6-7 6s-7-3-7-6zM5 2h14v4H5zM2 11h3v2H2zm17 0h3v2h-3zM8 10h3v2H8zm5 0h3v2h-3zM8 15h8v1.2H8z',
  [HalloweenIcon.GRAVE_CROSS]: 'M10 3h4v5h5v4h-5v10h-4V12H5V8h5z',
  [HalloweenIcon.HAUNTED_TREE]: 'M11 22v-6l-4-3 1-1 3 2V9L7 5l1-1 3 3V2h2v5l3-3 1 1-4 4v4l3-2 1 1-4 3v6zM5 22h14v-1H5z',
  [HalloweenIcon.HOURGLASS]:
    'M5 2h14v2l-1 1c0 3-2 5-4 7 2 2 4 4 4 7l1 1v2H5v-2l1-1c0-3 2-5 4-7-2-2-4-4-4-7L5 4zm3.5 3h7c0 2-1.2 3.5-3.5 5.5C9.7 8.5 8.5 7 8.5 5zM12 13.5c2.3 2 3.5 3.5 3.5 5.5h-7c0-2 1.2-3.5 3.5-5.5z',
  [HalloweenIcon.KEY]:
    'M15 2a7 7 0 0 0-6.7 9L2 17.3V22h4v-2h2v-2h2l2.3-2.3A7 7 0 1 0 15 2zm2 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4z',
  [HalloweenIcon.LANTERN]:
    'M11 1h2v2h2v2H9V3h2zM8 6h8l2 11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm3 13h2v2h2v2H9v-2h2zM10 8h4l1 8H9zm2 2c1 1.5 1.5 2.3 1.5 3.3a1.5 1.5 0 0 1-3 0c0-1 .5-1.8 1.5-3.3z',
  [HalloweenIcon.MAGIC_WAND]:
    'M4 20 18 6l-2-2L2 18zM20 2l.8 2.2L23 5l-2.2.8L20 8l-.8-2.2L17 5l2.2-.8zM13 3l.5 1.5L15 5l-1.5.5L13 7l-.5-1.5L11 5l1.5-.5zM21 11l.5 1.5L23 13l-1.5.5L21 15l-.5-1.5L19 13l1.5-.5z',
  [HalloweenIcon.MOON_CLOUD]:
    'M15 2a7 7 0 1 0 5.6 11.2A5.6 5.6 0 0 1 15 2zM7 22a4 4 0 0 1-.5-8A5 5 0 0 1 16 13a3.5 3.5 0 0 1 1 6.9V22z',
  [HalloweenIcon.MUMMY]:
    'M12 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21zM4 6h16v1.6H4zM3 9.5h18v1.4H3zm.5 5.5h17v1.4h-17zM5 18.5h14v1.4H5zM8.5 12a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zm7 0a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2z',
  [HalloweenIcon.MUSHROOM]:
    'M12 2C6 2 2 6 2 10c0 1 1 2 2 2h16c1 0 2-1 2-2 0-4-4-8-10-8zM8 12h8l-1 10h-6zM7 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm10-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-5-2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z',
  [HalloweenIcon.OWL]:
    'M12 3c-5 0-8 3-8 8v10h16V11c0-5-3-8-8-8zM5 4l1 4 2-3zm14 0-1 4-2-3zM8.5 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm7 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-7 1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm7 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM12 14l-1.5 2.5h3z',
  [HalloweenIcon.PENTAGRAM]:
    'M12 2l2.4 7.2H22l-6.2 4.5 2.4 7.3-6.2-4.5-6.2 4.5 2.4-7.3L2 9.2h7.6zm0 5.6 1.2 3.6h3.8l-3.1 2.2 1.2 3.7-3.1-2.3-3.1 2.3 1.2-3.7-3.1-2.2h3.8z',
  [HalloweenIcon.PITCHFORK]: 'M4 2h2v6h4V2h2v6h4V2h2v6a3 3 0 0 1-3 3h-2v11h-2V11H7a3 3 0 0 1-3-3z',
  [HalloweenIcon.RAVEN]:
    'M3 13c3-1 5-1 7-3 0-3 2-5 5-5l3-1-2 2c2 1 3 3 3 5 0 4-3 7-7 7h-2l-2 3-1-1 1-2c-3 0-5-2-5-5zm12-5.5a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6z',
  [HalloweenIcon.SCYTHE]: 'M4 22 14 8l-1.5-1L3 21zM13 6c4-4 9-3 10 2-3-1-6 0-8 3z',
  [HalloweenIcon.SNAKE]:
    'M17 3a3 3 0 0 0-3 3v1H8a4 4 0 0 0 0 8h7a2 2 0 0 1 0 4H5v2h10a4 4 0 0 0 0-8H8a2 2 0 0 1 0-4h6v1a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0z',
  [HalloweenIcon.SPELL_BOOK]:
    'M4 3h13a2 2 0 0 1 2 2v12H6a2 2 0 0 0-2 2zM4 19a2 2 0 0 0 2 2h13v-2H6zM11.5 7l1.2 2.5 2.7.3-2 1.9.5 2.7-2.4-1.3-2.4 1.3.5-2.7-2-1.9 2.7-.3z',
  [HalloweenIcon.VAMPIRE]:
    'M12 2 9 5H5c0 7 3 12 7 15 4-3 7-8 7-15h-4zM9 9h2.5v2H9zm3.5 0H15v2h-2.5zM8.5 14h7v1.2h-7zM10 15.2h1.4l-.7 2.6zm2.6 0H14l-.7 2.6z',
  [HalloweenIcon.WEB]:
    'M21.4 1.9L19.6 21.9L20.9 22L22.6 2.1zM21.4 1.8L13.9 20.3L15.1 20.8L22.6 2.2zM21.5 1.6L8.6 16.9L9.6 17.7L22.5 2.4zM21.7 1.4L4.7 12L5.4 13.1L22.3 2.6zM21.8 1.4L2.4 6.2L2.8 7.5L22.2 2.6zM22 1.4L2.1 0.3L2 1.6L22 2.6zM21.9 7.5L21.6 7.4L21.2 8.4L21.5 8.5zM21.7 7.4L21.4 7.2L20.8 8.1L21 8.3zM21.4 7.2L21.1 7L20.6 8L20.9 8.1zM20.8 7L20.5 7L20.5 8.1L20.9 8.1zM20.4 7L20 7.1L20.3 8.2L20.7 8.1zM20.2 7.1L19.9 7.1L19.8 8.2L20.1 8.2zM20.2 7.2L19.9 7L19.3 7.8L19.5 8zM20.1 7.1L19.9 6.8L18.9 7.4L19.1 7.7zM19.8 6.7L19.6 6.5L18.8 7.3L19 7.5zM19.3 6.4L19 6.3L18.7 7.3L19 7.4zM18.9 6.3L18.6 6.2L18.5 7.3L18.8 7.4zM18.7 6.3L18.4 6.2L18 7.2L18.3 7.3zM18.7 6.4L18.5 6.1L17.6 6.7L17.8 7zM18.6 6.2L18.5 5.9L17.4 6.2L17.5 6.5zM18.4 5.8L18.3 5.5L17.3 6L17.5 6.3zM18.1 5.3L17.8 5.1L17.2 6.1L17.5 6.2zM17.8 5.1L17.4 5L17 6L17.3 6.1zM17.6 5L17.3 4.8L16.6 5.7L16.9 5.9zM17.5 5.1L17.4 4.8L16.4 5.1L16.4 5.4zM17.4 5L17.4 4.6L16.3 4.6L16.3 4.9zM17.4 4.5L17.4 4.2L16.3 4.4L16.4 4.7zM17.3 3.9L17.1 3.7L16.2 4.4L16.4 4.6zM17 3.6L16.7 3.4L16 4.2L16.3 4.5zM16.8 3.5L16.7 3.3L15.7 3.8L15.9 4.1zM16.8 3.6L16.8 3.3L15.7 3.2L15.7 3.5zM16.7 3.4L16.9 3.1L15.8 2.7L15.7 3zM16.9 3L16.9 2.7L15.8 2.5L15.8 2.8zM16.9 2.4L16.8 2.1L15.8 2.5L15.9 2.8zM16.7 2L16.6 1.7L15.6 2.3L15.8 2.6zM16.6 1.9L16.5 1.5L15.5 1.8L15.6 2.1zM21.6 12.5L21.1 12.3L20.7 13.3L21.2 13.5zM21.2 12.3L20.7 11.9L20 12.8L20.5 13.2zM20.6 11.9L20.1 11.6L19.6 12.6L20.1 12.9zM19.8 11.6L19.2 11.6L19.3 12.7L19.9 12.7zM19.1 11.6L18.5 11.8L18.8 12.8L19.4 12.7zM18.7 11.8L18.1 11.7L18 12.8L18.6 12.9zM18.4 11.8L17.9 11.5L17.2 12.3L17.7 12.7zM18 11.6L17.7 11.1L16.8 11.7L17.1 12.2zM17.6 11L17.2 10.6L16.4 11.3L16.8 11.7zM17 10.4L16.4 10.3L16.1 11.3L16.7 11.5zM16.3 10.3L15.7 10.2L15.6 11.3L16.2 11.4zM15.8 10.3L15.3 10L14.9 11.1L15.4 11.3zM15.5 10.2L15.2 9.7L14.3 10.4L14.6 10.9zM15.3 9.9L15.1 9.3L14 9.6L14.2 10.2zM15.1 9.2L14.8 8.7L13.8 9.2L14.1 9.7zM14.6 8.5L14.1 8.1L13.5 9.1L14 9.4zM14 8.1L13.4 7.9L13 8.9L13.6 9.1zM13.6 7.9L13.1 7.6L12.4 8.4L12.9 8.8zM13.3 7.8L13.1 7.3L12.1 7.6L12.2 8.1zM13.2 7.4L13.2 6.8L12.1 6.7L12.1 7.4zM13.2 6.7L13.1 6.1L12 6.3L12.1 6.9zM13 5.9L12.6 5.4L11.8 6.1L12.1 6.6zM12.5 5.3L12 4.9L11.3 5.8L11.8 6.2zM12.2 5.1L11.8 4.6L10.9 5.1L11.2 5.6zM11.9 4.9L12 4.3L10.9 4.2L10.8 4.8zM11.9 4.4L12.1 3.8L11.1 3.5L10.9 4.1zM12.2 3.7L12.3 3.2L11.2 3L11.1 3.6zM12.2 2.9L12 2.3L11 2.7L11.2 3.3zM12 2.3L11.6 1.7L10.7 2.3L11 2.8zM11.7 1.9L11.5 1.3L10.5 1.6L10.6 2.1zM21.4 17.5L20.5 17.2L20.2 18.2L21 18.5zM20.7 17.2L19.9 16.7L19.3 17.5L20 18.1zM19.9 16.6L19.1 16.2L18.6 17.2L19.4 17.6zM18.8 16.2L18 16.2L18.1 17.3L18.9 17.3zM17.9 16.2L17 16.5L17.3 17.5L18.2 17.3zM17.2 16.4L16.3 16.4L16.2 17.5L17.1 17.5zM16.6 16.5L15.9 16L15.2 16.8L15.9 17.4zM16 16.1L15.5 15.3L14.6 15.9L15.1 16.7zM15.5 15.2L14.9 14.6L14.1 15.4L14.7 16zM14.6 14.5L13.8 14.3L13.5 15.3L14.3 15.6zM13.7 14.3L12.8 14.2L12.7 15.3L13.6 15.4zM12.9 14.2L12.1 13.9L11.7 14.9L12.5 15.3zM12.4 14.1L11.9 13.4L11 14L11.5 14.7zM12 13.6L11.7 12.7L10.7 13L10.9 13.9zM11.7 12.6L11.3 11.8L10.3 12.3L10.7 13.1zM11.1 11.6L10.4 11.2L9.8 12.1L10.5 12.5zM10.3 11.1L9.5 10.8L9 11.8L9.9 12.1zM9.6 10.8L8.9 10.3L8.2 11.1L8.9 11.7zM9.1 10.6L8.9 9.7L7.8 10L8.1 10.9zM8.9 9.9L8.9 9L7.8 8.9L7.8 9.9zM8.9 8.9L8.8 8L7.7 8.2L7.8 9zM8.7 7.8L8.2 7.1L7.3 7.8L7.8 8.5zM8.1 7.1L7.4 6.4L6.7 7.3L7.4 7.9zM7.5 6.6L7 5.8L6.1 6.4L6.5 7.2zM7.1 6.2L7.1 5.3L6 5.3L6 6.1zM7.1 5.5L7.4 4.6L6.4 4.2L6.1 5.1zM7.5 4.5L7.6 3.7L6.5 3.5L6.4 4.3zM7.6 3.4L7.3 2.6L6.2 3L6.5 3.8zM7.2 2.5L6.7 1.7L5.8 2.3L6.3 3.1zM6.8 1.9L6.6 1L5.5 1.3L5.7 2.1z',
  [HalloweenIcon.WOLF_HEAD]: 'M4 2l4 6h8l4-6v9c0 5-3 9-8 11-5-2-8-6-8-11zM8.5 11l3 1-3 1zm7 0-3 1 3 1zm-5 4h3l-1.5 2z',
  [HalloweenIcon.ZOMBIE_HAND]: 'M10 22V12l-3-5 1.5-1 2.5 3V3h2v6h1V2h2v7h1V4h2v7h1V7h2v8c0 4-3 7-7 7z',
  [HalloweenIcon.BAT]:
    'M12 6c-.6 0-1.1.4-1.3 1C9.4 5.3 7 4.3 4 4.3c-1.4 0-3 .6-3 .6s1.8.5 2.2 2.2C1.8 7.4 1 8.3 1 8.3s1.6.1 2.5 1.3C2.7 10 2.2 11.3 2.2 11.3s2-1 3.6-.5c1.3.4 2.4 1.7 3.4 2.8.7.8 1.7.9 2.8.9s2.1-.1 2.8-.9c1-1.1 2.1-2.4 3.4-2.8 1.6-.5 3.6.5 3.6.5s-.5-1.3-1.3-1.7C21.4 8.4 23 8.3 23 8.3s-.8-.9-2.2-1.2C21.2 5.4 23 4.9 23 4.9s-1.6-.6-3-.6c-3 0-5.4 1-6.7 2.7-.2-.6-.7-1-1.3-1z',
  [HalloweenIcon.BONES]:
    'M5.3 4a1.6 1.6 0 0 1 2.3 0l.2.2 10 10 .2.2a1.6 1.6 0 1 1-2.3 2.3l-.2-.2-10-10-.2-.2A1.6 1.6 0 0 1 5.3 4zM18.7 4a1.6 1.6 0 0 0-2.3 0l-.2.2-10 10-.2.2a1.6 1.6 0 1 0 2.3 2.3l.2-.2 10-10 .2-.2A1.6 1.6 0 0 0 18.7 4z',
  [HalloweenIcon.BROOM]:
    'M20.5 2.1l1.4 1.4-9.2 9.2-1.4-1.4zM10.2 12.4l1.4 1.4-1 1c-.8 2.5-2.8 5-6 7.2L2 19.4c2.2-3.2 4.7-5.2 7.2-6z',
  [HalloweenIcon.CANDLE]:
    'M10 8h4v11h-4zM8 19h8v3H8zM12 1c1.5 1.8 2.2 3 2.2 4.1A2.2 2.2 0 0 1 12 7.3a2.2 2.2 0 0 1-2.2-2.2C9.8 4 10.5 2.8 12 1z',
  [HalloweenIcon.CANDY]: 'M8 8h8a4 4 0 0 1 0 8H8a4 4 0 0 1 0-8zM2 6l5 3-2 3 2 3-5 3zM22 6l-5 3 2 3-2 3 5 3z',
  [HalloweenIcon.CAT]:
    'M4 4l4 3h8l4-3v8c0 5-3.6 9-8 9s-8-4-8-9zM9 11a1.3 1.3 0 1 0 0 2.6A1.3 1.3 0 0 0 9 11zm6 0a1.3 1.3 0 1 0 0 2.6A1.3 1.3 0 0 0 15 11z',
  [HalloweenIcon.CAULDRON]:
    'M3 9h18v2h-1.3c.8.9 1.3 2 1.3 3 0 3.3-4 6-9 6s-9-2.7-9-6c0-1 .5-2.1 1.3-3H3zM7.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM12 1.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM16.5 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM6 19.5 4.5 22h2zM18 19.5l1.5 2.5h-2z',
  [HalloweenIcon.COFFIN]: 'M9 2h6l4 6-2.5 14h-9L5 8zM11 8v3H8v2h3v5h2v-5h3v-2h-3V8z',
  [HalloweenIcon.CRYSTAL_BALL]:
    'M12 3a7 7 0 0 1 5.6 11.2H6.4A7 7 0 0 1 12 3zm-3 4a3 3 0 0 1 2.5-1.5l.3 1.2A2 2 0 0 0 10 8zM6 16h12l2 5H4z',
  [HalloweenIcon.EYE]:
    'M12 5C6.5 5 2.3 8.6 1 12c1.3 3.4 5.5 7 11 7s9.7-3.6 11-7c-1.3-3.4-5.5-7-11-7zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
  [HalloweenIcon.GHOST]:
    'M12 2a8 8 0 0 0-8 8v11l2.7-2 2.6 2 2.7-2 2.7 2 2.6-2 2.7 2V10a8 8 0 0 0-8-8zM9 9.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm6 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z',
  [HalloweenIcon.HAUNTED_HOUSE]: 'M3 11l9-8 9 8h-2v10h-5v-5h-4v5H5V11zM8 12h3v3H8zm5 0h3v3h-3z',
  [HalloweenIcon.MOON]: 'M13.2 2a10 10 0 1 0 8.6 15.2A8 8 0 0 1 13.2 2z',
  [HalloweenIcon.POTION]:
    'M9 2h6v2h-1v4.5l5.2 8.7A2.5 2.5 0 0 1 17 21H7a2.5 2.5 0 0 1-2.2-3.8L10 8.5V4H9zm3 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.5-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z',
  [HalloweenIcon.PUMPKIN]:
    'M11 2h2v3h-2zM12 5C7 5 3 8.2 3 13s4 9 9 9 9-4.2 9-9-4-8-9-8zM7.5 11.5l2-2 1 2.5zm9 0-2-2-1 2.5zM7 15.5c1.5 1.8 3 2.5 5 2.5s3.5-.7 5-2.5l-1.3.8-1-.9-1.2 1-1.5-1-1.5 1-1.2-1-1 .9z',
  [HalloweenIcon.SKULL]:
    'M12 2a8 8 0 0 0-8 8c0 2.6 1.2 4.9 3 6.3V19a1 1 0 0 0 1 1h1v2h2v-2h2v2h2v-2h1a1 1 0 0 0 1-1v-2.7c1.8-1.4 3-3.7 3-6.3a8 8 0 0 0-8-8zM9 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-3 4.5-1.2 2.5h2.4z',
  [HalloweenIcon.SPIDER]:
    'M12 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1c2.5 0 4 2 4 5s-1.5 6-4 6-4-3-4-6 1.5-5 4-5zM8.6 11.8 3 8.5l.6-1 5.6 3.3zm6.8 0L21 8.5l-.6-1-5.6 3.3zM8.3 14H2v1.2h6.3zm7.4 0H22v1.2h-6.3zM8.6 16.6 3.5 20l.7.9 5.1-3.4zm6.8 0 5.1 3.4-.7.9-5.1-3.4z',
  [HalloweenIcon.TOMBSTONE]: 'M12 2a8 8 0 0 0-8 8v9H2v3h20v-3h-2v-9a8 8 0 0 0-8-8zm-1 5v3H8v2h3v5h2v-5h3v-2h-3V7z',
  [HalloweenIcon.WITCH_HAT]:
    'M12.5 2l5.5 12.5c-1.5.6-3.6 1-6 1s-4.5-.4-6-1zM2 17c0-1.2 4.5-2.2 10-2.2s10 1 10 2.2-4.5 2.2-10 2.2S2 18.2 2 17z',
};

export const HALLOWEEN_ICONS = Object.fromEntries(
  Object.values(HalloweenIcon).map(name => [
    name,
    defineSeasonalIcon(`Halloween${name[0].toUpperCase()}${name.slice(1)}`, ICON_PATHS[name]),
  ]),
) as Record<HalloweenIcon, ReturnType<typeof defineSeasonalIcon>>;

// One distinct Halloween icon per side-nav entry, keyed by the entry's label.
export const NAV_LABEL_ICONS: Record<string, HalloweenIcon> = {
  'A/B Tests': HalloweenIcon.HOURGLASS,
  'AI Spend': HalloweenIcon.FLAME,
  'Account Admin': HalloweenIcon.WOLF_HEAD,
  'Account Dashboard': HalloweenIcon.HAUNTED_TREE,
  Admin: HalloweenIcon.TOMBSTONE,
  Analytics: HalloweenIcon.CRYSTAL_BALL,
  'Analytics API': HalloweenIcon.SPELL_BOOK,
  'App Marketplace': HalloweenIcon.LANTERN,
  'App Review': HalloweenIcon.SCYTHE,
  Apps: HalloweenIcon.MUSHROOM,
  'Bot Pairings': HalloweenIcon.CAT,
  Brands: HalloweenIcon.BROOM,
  'Child Account Dashboard': HalloweenIcon.CASTLE,
  'Child Accounts': HalloweenIcon.MOON_CLOUD,
  'Claim Automation': HalloweenIcon.CAULDRON,
  Collaborations: HalloweenIcon.CANDELABRA,
  'Control Panel': HalloweenIcon.SPIDER,
  Customers: HalloweenIcon.VAMPIRE,
  Customizations: HalloweenIcon.POTION,
  Dashboard: HalloweenIcon.MOON,
  Developer: HalloweenIcon.MAGIC_WAND,
  Engineering: HalloweenIcon.PITCHFORK,
  Feedback: HalloweenIcon.BAT,
  Finance: HalloweenIcon.KEY,
  Gallery: HalloweenIcon.RAVEN,
  'Global Macros': HalloweenIcon.WITCH_HAT,
  History: HalloweenIcon.GRAVE_CROSS,
  Implementation: HalloweenIcon.AXE,
  Insights: HalloweenIcon.EYE,
  Integrations: HalloweenIcon.SNAKE,
  Macros: HalloweenIcon.PENTAGRAM,
  Models: HalloweenIcon.FRANKENSTEIN,
  Orders: HalloweenIcon.PUMPKIN,
  Organization: HalloweenIcon.FENCE,
  Payments: HalloweenIcon.CHAINS,
  Payouts: HalloweenIcon.CANDY_CORN,
  'Post-Claim': HalloweenIcon.ZOMBIE_HAND,
  Products: HalloweenIcon.CANDY,
  Returns: HalloweenIcon.COFFIN,
  Reviews: HalloweenIcon.OWL,
  Settings: HalloweenIcon.WEB,
  'Shipping Claims': HalloweenIcon.GHOST,
  'Store Credit': HalloweenIcon.POISON_APPLE,
  Stores: HalloweenIcon.HAUNTED_HOUSE,
  'Team Members': HalloweenIcon.SKULL,
  Themes: HalloweenIcon.CANDLE,
  Users: HalloweenIcon.BONES,
  'Warranty Claims': HalloweenIcon.MUMMY,
  Whitelabel: HalloweenIcon.SCREAM_MASK,
};
